import React from 'react'
import './CaseStudy.css'
import workFlowImage from '../../img/workflow.jpg';
// import workFlowImage2 from '../../img/WorkFlow2.jpg';
import workLoadImage from '../../img/workload.jpg';
import saasImage from '../../img/Saas.jpg';
import mobileDevImage from '../../img/mobile_development.jpg';
import fitnessImage from '../../img/fitness.jpg';
import nutritionImage from '../../img/nutrition.jpg';

export default function CaseStudy() {
  return (
    <section className="case-studies">
  <header className="case-header">
    <h1>Case Studies</h1>
    <button className="view-all-btn-c"> All Cases</button>
  </header>
  <div className="case-grid">
   
    <div className="case-card">
      <img src={workFlowImage} alt="Workflow System" />
      <div className="card-content">
        <span className="badge badge-blue">Oil & gas</span>
        <div className="flex-show">
        <h3>Workflow System Energy</h3>
        <div className="arrow-c">↗</div> 
        </div>   
      </div>
    </div>

    <div className="case-card">
      <img src={saasImage} alt="SaaS Analytics" />
      <div className="card-content">
        <span className="badge badge-blue">Ecommerce</span>
        <div className="flex-show">
        <h3>SaaS for End-to-End Analytics</h3>
        <div className="arrow-c">↗</div> 
        </div>   
      </div>
    </div>
  
    <div className="case-card">
      <img src={workLoadImage} alt="Workload Management" />
      <div className="card-content">
        <span className="badge badge-blue">Web Development</span>
        <div className="flex-show">
        <h3>Workload Management</h3>
        <div className="arrow-c">↗</div> 
        </div>
      </div>
    </div>
   
    <div className="case-card">
      <img src={mobileDevImage} alt="Mobile App" />
      <div className="card-content">
        <span className="badge badge-blue">Oil & gas</span>
        <div className="flex-show">
        <h3>Qpay E-wallet mobile</h3>
        <div className="arrow-c">↗</div> 
        </div>
       
      </div>
    </div>
   
    <div className="case-card">
      <img src={fitnessImage} alt="E-learning Platform" />
      <div className="card-content">
        <span className="badge badge-blue">Ecommerce</span>
        <div className="flex-show">
        <h3>Fitness & Personal Trainers</h3>
        <div className="arrow-c">↗</div> 
        </div>
      </div>
    </div>
  
    <div className="case-card">
      <img src={nutritionImage} alt="Blockchain Solution" />
      <div className="card-content">
        <span className="badge badge-blue">Web Development</span>
        <div className="flex-show">
        <h3>Nutrition Coach & Nutritionist</h3>
        <div className="arrow-c">↗</div> 
        </div>
      </div>
    </div>
  </div>
</section>


  )
}
